/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreateMessageForConversation = /* GraphQL */ `
  subscription OnCreateMessageForConversation($conversationId: ID!) {
    onCreateMessageForConversation(conversationId: $conversationId) {
      conversationId
      text
      attachments {
        identityId
        key
        level
        type
      }
      users
      receiver
      sender
      createdBy
      readBy
      createdAt
      updatedAt
      id
      conversationMessagesId
    }
  }
`;
export const onCreateUserConversationForUser = /* GraphQL */ `
  subscription OnCreateUserConversationForUser($userId: ID!) {
    onCreateUserConversationForUser(userId: $userId) {
      conversationId
      conversation {
        title
        image {
          alt
          identityId
          key
          level
          type
        }
        country
        messages {
          nextToken
        }
        userConversations {
          nextToken
        }
        productId
        product {
          title
          category
          description
          tags
          locations
          country
          status
          owner
          teamId
          expiresAt
          createdAt
          updatedAt
          id
        }
        users
        readBy
        createdBy
        createdAt
        updatedAt
        id
      }
      userId
      user {
        id
        identityId
        email
        about
        firstName
        lastName
        phone
        blocked
        blockedBy
        country
        profileImg {
          alt
          identityId
          key
          level
          type
        }
        interests
        locations
        facebook
        instagram
        twitter
        linkedin
        locale
        billingId
        billing {
          customerId
          userId
          planId
          productId
          autoRenewProductId
          subscriptionId
          status
          trialUsed
          paymentProvider
          purchaseToken
          plan
          expiresAt
          cancelledAt
          createdAt
          updatedAt
          id
          owner
        }
        onboardingStatus
        teamId
        team {
          billingId
          title
          ownerUserId
          createdAt
          updatedAt
          id
          owner
        }
        userType
        reportReasons
        createdAt
        updatedAt
        owner
      }
      users
      createdAt
      updatedAt
      id
      conversationUserConversationsId
    }
  }
`;
export const onCreateMessageForSenderUser = /* GraphQL */ `
  subscription OnCreateMessageForSenderUser($sender: String!) {
    onCreateMessageForSenderUser(sender: $sender) {
      conversationId
      text
      attachments {
        identityId
        key
        level
        type
      }
      users
      receiver
      sender
      createdBy
      readBy
      createdAt
      updatedAt
      id
      conversationMessagesId
    }
  }
`;
export const onCreateMessageForReceiverUser = /* GraphQL */ `
  subscription OnCreateMessageForReceiverUser($receiver: String!) {
    onCreateMessageForReceiverUser(receiver: $receiver) {
      conversationId
      text
      attachments {
        identityId
        key
        level
        type
      }
      users
      receiver
      sender
      createdBy
      readBy
      createdAt
      updatedAt
      id
      conversationMessagesId
    }
  }
`;
export const onCreateConversation = /* GraphQL */ `
  subscription OnCreateConversation(
    $filter: ModelSubscriptionConversationFilterInput
  ) {
    onCreateConversation(filter: $filter) {
      title
      image {
        alt
        identityId
        key
        level
        type
      }
      country
      messages {
        items {
          conversationId
          text
          users
          receiver
          sender
          createdBy
          readBy
          createdAt
          updatedAt
          id
          conversationMessagesId
        }
        nextToken
      }
      userConversations {
        items {
          conversationId
          userId
          users
          createdAt
          updatedAt
          id
          conversationUserConversationsId
        }
        nextToken
      }
      productId
      product {
        title
        category
        description
        images {
          alt
          identityId
          key
          level
          type
        }
        tags
        locations
        country
        status
        owner
        teamId
        expiresAt
        createdAt
        updatedAt
        id
      }
      users
      readBy
      createdBy
      createdAt
      updatedAt
      id
    }
  }
`;
export const onUpdateConversation = /* GraphQL */ `
  subscription OnUpdateConversation(
    $filter: ModelSubscriptionConversationFilterInput
  ) {
    onUpdateConversation(filter: $filter) {
      title
      image {
        alt
        identityId
        key
        level
        type
      }
      country
      messages {
        items {
          conversationId
          text
          users
          receiver
          sender
          createdBy
          readBy
          createdAt
          updatedAt
          id
          conversationMessagesId
        }
        nextToken
      }
      userConversations {
        items {
          conversationId
          userId
          users
          createdAt
          updatedAt
          id
          conversationUserConversationsId
        }
        nextToken
      }
      productId
      product {
        title
        category
        description
        images {
          alt
          identityId
          key
          level
          type
        }
        tags
        locations
        country
        status
        owner
        teamId
        expiresAt
        createdAt
        updatedAt
        id
      }
      users
      readBy
      createdBy
      createdAt
      updatedAt
      id
    }
  }
`;
export const onDeleteConversation = /* GraphQL */ `
  subscription OnDeleteConversation(
    $filter: ModelSubscriptionConversationFilterInput
  ) {
    onDeleteConversation(filter: $filter) {
      title
      image {
        alt
        identityId
        key
        level
        type
      }
      country
      messages {
        items {
          conversationId
          text
          users
          receiver
          sender
          createdBy
          readBy
          createdAt
          updatedAt
          id
          conversationMessagesId
        }
        nextToken
      }
      userConversations {
        items {
          conversationId
          userId
          users
          createdAt
          updatedAt
          id
          conversationUserConversationsId
        }
        nextToken
      }
      productId
      product {
        title
        category
        description
        images {
          alt
          identityId
          key
          level
          type
        }
        tags
        locations
        country
        status
        owner
        teamId
        expiresAt
        createdAt
        updatedAt
        id
      }
      users
      readBy
      createdBy
      createdAt
      updatedAt
      id
    }
  }
`;
export const onCreateUserConversation = /* GraphQL */ `
  subscription OnCreateUserConversation(
    $filter: ModelSubscriptionUserConversationFilterInput
  ) {
    onCreateUserConversation(filter: $filter) {
      conversationId
      conversation {
        title
        image {
          alt
          identityId
          key
          level
          type
        }
        country
        messages {
          nextToken
        }
        userConversations {
          nextToken
        }
        productId
        product {
          title
          category
          description
          tags
          locations
          country
          status
          owner
          teamId
          expiresAt
          createdAt
          updatedAt
          id
        }
        users
        readBy
        createdBy
        createdAt
        updatedAt
        id
      }
      userId
      user {
        id
        identityId
        email
        about
        firstName
        lastName
        phone
        blocked
        blockedBy
        country
        profileImg {
          alt
          identityId
          key
          level
          type
        }
        interests
        locations
        facebook
        instagram
        twitter
        linkedin
        locale
        billingId
        billing {
          customerId
          userId
          planId
          productId
          autoRenewProductId
          subscriptionId
          status
          trialUsed
          paymentProvider
          purchaseToken
          plan
          expiresAt
          cancelledAt
          createdAt
          updatedAt
          id
          owner
        }
        onboardingStatus
        teamId
        team {
          billingId
          title
          ownerUserId
          createdAt
          updatedAt
          id
          owner
        }
        userType
        reportReasons
        createdAt
        updatedAt
        owner
      }
      users
      createdAt
      updatedAt
      id
      conversationUserConversationsId
    }
  }
`;
export const onUpdateUserConversation = /* GraphQL */ `
  subscription OnUpdateUserConversation(
    $filter: ModelSubscriptionUserConversationFilterInput
  ) {
    onUpdateUserConversation(filter: $filter) {
      conversationId
      conversation {
        title
        image {
          alt
          identityId
          key
          level
          type
        }
        country
        messages {
          nextToken
        }
        userConversations {
          nextToken
        }
        productId
        product {
          title
          category
          description
          tags
          locations
          country
          status
          owner
          teamId
          expiresAt
          createdAt
          updatedAt
          id
        }
        users
        readBy
        createdBy
        createdAt
        updatedAt
        id
      }
      userId
      user {
        id
        identityId
        email
        about
        firstName
        lastName
        phone
        blocked
        blockedBy
        country
        profileImg {
          alt
          identityId
          key
          level
          type
        }
        interests
        locations
        facebook
        instagram
        twitter
        linkedin
        locale
        billingId
        billing {
          customerId
          userId
          planId
          productId
          autoRenewProductId
          subscriptionId
          status
          trialUsed
          paymentProvider
          purchaseToken
          plan
          expiresAt
          cancelledAt
          createdAt
          updatedAt
          id
          owner
        }
        onboardingStatus
        teamId
        team {
          billingId
          title
          ownerUserId
          createdAt
          updatedAt
          id
          owner
        }
        userType
        reportReasons
        createdAt
        updatedAt
        owner
      }
      users
      createdAt
      updatedAt
      id
      conversationUserConversationsId
    }
  }
`;
export const onDeleteUserConversation = /* GraphQL */ `
  subscription OnDeleteUserConversation(
    $filter: ModelSubscriptionUserConversationFilterInput
  ) {
    onDeleteUserConversation(filter: $filter) {
      conversationId
      conversation {
        title
        image {
          alt
          identityId
          key
          level
          type
        }
        country
        messages {
          nextToken
        }
        userConversations {
          nextToken
        }
        productId
        product {
          title
          category
          description
          tags
          locations
          country
          status
          owner
          teamId
          expiresAt
          createdAt
          updatedAt
          id
        }
        users
        readBy
        createdBy
        createdAt
        updatedAt
        id
      }
      userId
      user {
        id
        identityId
        email
        about
        firstName
        lastName
        phone
        blocked
        blockedBy
        country
        profileImg {
          alt
          identityId
          key
          level
          type
        }
        interests
        locations
        facebook
        instagram
        twitter
        linkedin
        locale
        billingId
        billing {
          customerId
          userId
          planId
          productId
          autoRenewProductId
          subscriptionId
          status
          trialUsed
          paymentProvider
          purchaseToken
          plan
          expiresAt
          cancelledAt
          createdAt
          updatedAt
          id
          owner
        }
        onboardingStatus
        teamId
        team {
          billingId
          title
          ownerUserId
          createdAt
          updatedAt
          id
          owner
        }
        userType
        reportReasons
        createdAt
        updatedAt
        owner
      }
      users
      createdAt
      updatedAt
      id
      conversationUserConversationsId
    }
  }
`;
export const onCreateMessage = /* GraphQL */ `
  subscription OnCreateMessage($filter: ModelSubscriptionMessageFilterInput) {
    onCreateMessage(filter: $filter) {
      conversationId
      text
      attachments {
        identityId
        key
        level
        type
      }
      users
      receiver
      sender
      createdBy
      readBy
      createdAt
      updatedAt
      id
      conversationMessagesId
    }
  }
`;
export const onUpdateMessage = /* GraphQL */ `
  subscription OnUpdateMessage($filter: ModelSubscriptionMessageFilterInput) {
    onUpdateMessage(filter: $filter) {
      conversationId
      text
      attachments {
        identityId
        key
        level
        type
      }
      users
      receiver
      sender
      createdBy
      readBy
      createdAt
      updatedAt
      id
      conversationMessagesId
    }
  }
`;
export const onCreateProduct = /* GraphQL */ `
  subscription OnCreateProduct(
    $filter: ModelSubscriptionProductFilterInput
    $owner: String
  ) {
    onCreateProduct(filter: $filter, owner: $owner) {
      title
      category
      description
      images {
        alt
        identityId
        key
        level
        type
      }
      tags
      locations
      country
      status
      owner
      teamId
      expiresAt
      createdAt
      updatedAt
      id
    }
  }
`;
export const onUpdateProduct = /* GraphQL */ `
  subscription OnUpdateProduct(
    $filter: ModelSubscriptionProductFilterInput
    $owner: String
  ) {
    onUpdateProduct(filter: $filter, owner: $owner) {
      title
      category
      description
      images {
        alt
        identityId
        key
        level
        type
      }
      tags
      locations
      country
      status
      owner
      teamId
      expiresAt
      createdAt
      updatedAt
      id
    }
  }
`;
export const onDeleteProduct = /* GraphQL */ `
  subscription OnDeleteProduct(
    $filter: ModelSubscriptionProductFilterInput
    $owner: String
  ) {
    onDeleteProduct(filter: $filter, owner: $owner) {
      title
      category
      description
      images {
        alt
        identityId
        key
        level
        type
      }
      tags
      locations
      country
      status
      owner
      teamId
      expiresAt
      createdAt
      updatedAt
      id
    }
  }
`;
export const onUpdateTeam = /* GraphQL */ `
  subscription OnUpdateTeam(
    $filter: ModelSubscriptionTeamFilterInput
    $owner: String
  ) {
    onUpdateTeam(filter: $filter, owner: $owner) {
      billingId
      title
      teamUsers {
        items {
          teamId
          userId
          createdAt
          updatedAt
          owners
          id
          teamTeamUsersId
        }
        nextToken
      }
      ownerUserId
      createdAt
      updatedAt
      id
      owner
    }
  }
`;
